/** Exposure of this frontend experiment; API permissions remain authoritative. */
export function canUsePhaseLoadTrial(store) {
    return store.getters.isLoggedIn === true && Boolean(store.getters.token)
        && store.getters.userdata?.username === "riccardo";
}

export function phaseLoadTrialDestination(store, route) {
    if (!store.getters.isLoggedIn) return "/login";
    if (canUsePhaseLoadTrial(store)) return undefined;
    return { name: "av-fase", params: route.params, query: route.query, hash: route.hash, replace: true };
}

/** Fase updates history directly: use the visible URL, not stale router params. */
export function phaseVersionTarget(path, enabled) {
    if (!/^\/av\/(?:fase|fase-load-v2)\/[^/?#]+(?:\/[^/?#]+){0,2}\/?(?:\?[^#]*)?(?:#.*)?$/.test(path)) return null;
    return path.replace(/^\/av\/(?:fase|fase-load-v2)(?=\/)/, enabled ? "/av/fase-load-v2" : "/av/fase");
}
